import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {

  	transform(value, args:string[]) : any {
	 	let keys = [];
	 	if(value && value.length > 0){
	 		for (let key in value) {
	      		keys.push({key: key, value: value[key]});
	    	}
	 	}
	    return keys;
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/keys.pipe.ts